export enum Steps {
  QUESTIONNAIRE_INSTRUCTIONS = '1_s',
  // Personal Information
  PREVIOUS_NAMES_QUESTION = '2_q',
  PREVIOUS_NAMES_FORM = '2_f',
  CIVIL_SERVICE_EXPERIENCE_QUESTION = '3_q',
  CIVIL_SERVICE_EXPERIENCE_UNAVAILABLE = '3_s',
  RGS_EMPLOYEE_RELATIVES_QUESTION = '4_q',
  RGS_EMPLOYEE_RELATIVES_FORM = '4_f',
  // Experience and Qualifications
  PROFESSIONAL_EDUCATION_QUESTION = '5_q',
  PROFESSIONAL_EDUCATION_FORM = '5_f',
  INSURANCE_AGENT_EXPERIENCE_QUESTION = '6_q',
  INSURANCE_AGENT_EXPERIENCE_LIST_FORM = '6_f_1',
  INSURANCE_AGENT_EXPERIENCE_DETAILS_FORM = '6_f_2',
  //
  OTHER_WORK_EXPERIENCE_QUESTION = '7_q',
  OTHER_WORK_EXPERIENCE_FORM = '7_f',
  LEGAL_ENTITY_FOUNDER_STATUS_QUESTION = '8_q',
  LEGAL_ENTITY_FOUNDER_STATUS_FORM = '8_f',
  SELF_EMPLOYMENT_STATUS_QUESTION = '9_q',
  SELF_EMPLOYMENT_STATUS_FORM = '9_f',
  QUESTIONNAIRE_RESULTS = '10_s',
}

export type StepsValues = `${Steps}`;
export type QuestionsStepsValues = Extract<StepsValues, `${string}_q`>;
export type FormsStepsValues = Extract<StepsValues, `${string}_f${string}`>;

export const RECORDS_PER_FORM_MIN = 1;
export const RECORDS_PER_FORM_MAX = 3;
